export const READING_TYPE_TEXT = 1
export const READING_TYPE_FILE = 2

export const VIDEO_TYPE_INTERNAL = 1
export const VIDEO_TYPE_EXTERNAL = 2
